import cx from 'classnames'
import { type FC, type PropsWithChildren } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from '@egw/i18n'
import { UnauthenticatedHeader } from '../components'

interface EnrollmentJointLayoutProps extends PropsWithChildren {
  className?: string
  title?: string
}

export const EnrollmentJointLayout: FC<EnrollmentJointLayoutProps> = ({
  children,
  className,
  title = 'Enrollment',
}) => {
  const { t } = useTranslation('layouts')
  const baseClass = cx('egw-container-enroll-joint')
  const finalClasses = twMerge(baseClass, className)

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={t('header.meta_content')} />
        </Helmet>
      </HelmetProvider>
      <div className="h-full flex flex-col overflow-auto">
        <UnauthenticatedHeader />
        <div className="flex-1">
          <div className={finalClasses}>{children}</div>
        </div>
      </div>
    </>
  )
}
